import { render, staticRenderFns } from "./TranslatedText.vue?vue&type=template&id=dcae9d50&scoped=true"
import script from "./TranslatedText.vue?vue&type=script&lang=js"
export * from "./TranslatedText.vue?vue&type=script&lang=js"
import style0 from "./TranslatedText.vue?vue&type=style&index=0&id=dcae9d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcae9d50",
  null
  
)

export default component.exports